import styled from 'styled-components';

export const Container = styled.h1(({ theme }) => ({
  margin: 0,
  fontSize: theme.typography.size24,
  fontFamily: theme.typography.family.playfairDisplay,
  color: theme.page.title.text,
  textTransform: 'uppercase',
}));
